import {Datoformatering} from "../tjenester/Datoformatering";

export function formaterDatoperiodeFilterForInjisering() {
    return [Datoformatering.regNavn, formaterDatoperiodeFilter];
}

/**
 * Formaterer angitt periode som streng.
 * Delegerer til Datoformatering.somPeriode().
 *
 * Periode forventes angitt som en array med to datoer; [start:Date, slutt:Date]
 */
export function formaterDatoperiodeFilter(datoformatering: Datoformatering): Function {
    return (periode: [Date, Date], format: string): string => {
        if (format === "lang") {
            return datoformatering.somPeriodeLang(periode[0], periode[1]);
        }

        if(format === 'middels') {
            return datoformatering.somPeriodeMiddelsLang(periode[0], periode[1]);
        }

        return datoformatering.somPeriode(periode[0], periode[1])
    }
}

